import { s16 } from '@ardoq/design-tokens';
import styled from 'styled-components';
import { FIELD_SELECTOR } from './Field/Field';
import { FormSize } from '../types';

type FieldsRowProps = {
  $formSize?: FormSize;
};

/**
 * @deprecated Use `Inline` instead
 */
export const FieldsRow = styled.div<FieldsRowProps>`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: ${s16};
  width: ${({ $formSize = FormSize.AUTO }) => $formSize};

  ${FIELD_SELECTOR} {
    width: 100%;
  }
`;
